/* ==============================================================
   MY LINK FOR ALL — store-wide custom scripts
   Loaded from snippets/global-script.liquid. Add future JS here.
   ============================================================== */

/* --------------------------------------------------------------
   Cart page: replace the native number input with a − n + pill.
   The theme's cart.js listens for change/input on the real input
   ([data-cart-quantity]), so we keep it in the DOM, hide it with
   CSS on mobile, and write into it. Same approach as the mini-cart
   pill in theme.liquid. Re-runs when the cart section re-renders.
   -------------------------------------------------------------- */
(function () {
  function buildPill(wrap) {
    if (wrap.dataset.mlfaQty) return;
    var input = wrap.querySelector('input.cart-item-qty-input');
    if (!input) return;
    wrap.dataset.mlfaQty = '1';

    var pill = document.createElement('div');
    pill.className = 'mlfa-cart-qty';
    pill.innerHTML =
      '<button type="button" class="mlfa-cq-btn" data-dir="-1" aria-label="Decrease quantity">&minus;</button>' +
      '<span class="mlfa-cq-num">' + (parseInt(input.value, 10) || 0) + '</span>' +
      '<button type="button" class="mlfa-cq-btn" data-dir="1" aria-label="Increase quantity">+</button>';
    wrap.appendChild(pill);

    var num = pill.querySelector('.mlfa-cq-num');

    pill.addEventListener('click', function (e) {
      var btn = e.target.closest('.mlfa-cq-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var dir = parseInt(btn.dataset.dir, 10) || 0;
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + dir);
      input.value = next;
      num.textContent = next;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    input.addEventListener('change', function () {
      num.textContent = input.value;
    });
  }

  function run() {
    document.querySelectorAll('.cart-item-qty').forEach(buildPill);
  }

  function start() {
    run();
    var target = document.getElementById('main-cart-items');
    if (target && window.MutationObserver) {
      new MutationObserver(function () { run(); }).observe(target, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
